var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6C7.34315 6 6 7.34315 6 9V39C6 40.6569 7.34315 42 9 42H39C40.6569 42 42 40.6569 42 39V9C42 7.34315 40.6569 6 39 6H9ZM36.1053 36.6316L38.6316 8H10L12.5263 36.6316L24.3158 40L36.1053 36.6316ZM20.7796 26.5263H17.4112L17.6645 31.1579L24.3158 33.3487L30.9671 31.1579L31.5592 21.4737L31.9803 14.7368H16.5691L16.8224 18.1053H28.4408L28.1908 21.4737H20.4408L20.6118 24.8421H28.0197L27.7697 28.6316L24.3158 29.8092L20.8618 28.6316L20.7796 26.5263Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.8f47ce7c6f9783f693d3834450d4c3e0.svg";
export { ForwardRef as ReactComponent };